import { getTracking } from "@website/store/tracking";
import { getChannel } from "@website/utils/channel/get-channel";

export const openBrowser = (
  url: string,
  target: "_blank" | "_self" = "_self"
) => {
  if (!url) return;

  const timer = setTimeout(() => {
    window.removeEventListener("blur", windowBlurHandler);
    window.removeEventListener(
      "visibilitychange",
      documentVisibilityChangeHandler
    );
    if (!document.hidden) {
      window.location.href = url;
    }
  }, 2500);

  const windowBlurHandler = () => {
    clearTimeout(timer);
    window.removeEventListener("blur", windowBlurHandler);
  };

  const documentVisibilityChangeHandler = () => {
    if (document.hidden) {
      clearTimeout(timer);
      document.removeEventListener(
        "visibilitychange",
        documentVisibilityChangeHandler
      );
    }
  };

  window.addEventListener("blur", windowBlurHandler);
  document.addEventListener(
    "visibilitychange",
    documentVisibilityChangeHandler
  );
  if (getTracking().isNative) {
    if (window.generateBrowserLink) {
      window.open(window.generateBrowserLink?.(url), target);
    } else {
      if (
        /(ipod|iphone|ipad)/i.test(
          window.navigator && window.navigator.userAgent
        )
      ) {
        return `openinbrowser://${url}`;
      }
      return `openinbrowser-${url}`;
    }
  } else if (["android", "ios"].includes(getChannel())) {
    window.open(`openinbrowser://${url.replace(/^https?:\/\//, "")}`, target);
  } else {
    window.open(url, target);
  }
};
